export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            了解天堂影院的故事与使命
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="rounded-lg bg-background-200/60 border border-background-200/50 p-6 md:p-10">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
              <div className="lg:w-[280px] shrink-0">
                <div className="w-full aspect-square rounded-lg overflow-hidden bg-background-300">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20cinema%20brand%20identity%20with%20film%20reel%20and%20spotlight%20on%20dark%20background%2C%20warm%20golden%20and%20crimson%20accents%2C%20premium%20movie%20theater%20aesthetic%2C%20classic%20and%20modern%20blend%2C%20sophisticated%20design%2C%20clean%20composition&width=560&height=560&seq=about-cinema&orientation=squarish"
                    alt="天堂影院品牌形象"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="flex-1">
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
                  <strong className="text-foreground-800">天堂影院</strong>成立于 2020 年，是国内领先的高清电影在线看平台。我们始终秉持"让每个人都能轻松享受电影"的初心，汇聚全球优质影视资源，为用户提供<strong className="text-foreground-800">高清不缓冲、流畅在线观看、极速播放无广告</strong>的极致观影体验。
                </p>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
                  经过多年发展，天堂影院已收录超过 <strong className="text-primary-500">20,000 部</strong> 高清电影，涵盖动作、科幻、悬疑、喜剧、爱情、动画等全品类，日均服务超百万观影用户。我们的片源团队每日更新，确保最新电影在线观看资源第一时间与观众见面。
                </p>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5">
                  未来，天堂影院将继续深耕高清影视在线领域，不断优化播放技术与内容质量，致力于打造华人地区最受欢迎的免费电影网站与电影大全平台。
                </p>

                <div className="grid grid-cols-3 gap-4">
                  <div className="text-center p-3 rounded-md bg-background-100">
                    <div className="font-heading text-lg font-bold text-primary-500">5+</div>
                    <div className="text-xs text-foreground-400 mt-0.5">运营年份</div>
                  </div>
                  <div className="text-center p-3 rounded-md bg-background-100">
                    <div className="font-heading text-lg font-bold text-accent-500">100w+</div>
                    <div className="text-xs text-foreground-400 mt-0.5">日均用户</div>
                  </div>
                  <div className="text-center p-3 rounded-md bg-background-100">
                    <div className="font-heading text-lg font-bold text-primary-500">99.9%</div>
                    <div className="text-xs text-foreground-400 mt-0.5">服务可用率</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}